export default [{ //用户认证
        path: '/auditsManagement/user',
        name: 'auditsManagementUser',
        meta: { title: '用户认证审核'},
        component: () =>
            import ('../../views/auditsManagement/user')
    },
    { //用户认证审核详情
      path: '/auditsManagement/user/detail/:type',
      name: 'auditsManagementUserDetail',
      meta: { title: '用户认证审核详情'},
      component: () =>
          import ('../../views/auditsManagement/userDetail')
  },
    { //债权融资申请审核
        path: '/auditsManagement/applicationDebt',
        name: 'auditsManagementApplicationDebt',
        meta: { title: '债权融资申请审核'},
        component: () =>
            import ('../../views/auditsManagement/applicationDebt')
    },
    { //债权融资申请审核详情
      path: '/auditsManagement/applicationDebt/detail/:type',
      name: 'auditsManagementApplicationDebtDetail',
      meta: { title: '债权融资申请审核详情'},
      component: () =>
          import ('../../views/auditsManagement/applicationDebtDetail')
  },
  { //债权融资申请审核产品详情
    path: '/auditsManagement/applicationDebt/company/detail/:type',
    name: 'auditsManagementApplicationDebtCompanyDetail',
    meta: { title: '债权融资申请审核产品详情'},
    component: () =>
        import ('../../views/auditsManagement/applicationDebtCompanyDetail')
},
    { //债权融资发布审核
        path: '/auditsManagement/releaseDebt',
        name: 'auditsManagementReleaseDebt',
        meta: { title: '债权融资发布审核'},
        component: () =>
            import ('../../views/auditsManagement/releaseDebt'),
    },
    { //债权融资发布审核详情
      path: '/auditsManagement/releaseDebt/detail/:type',
      name: 'auditsManagementReleaseDebtDetail',
      meta: { title: '债权融资发布审核详情'},
      component: () =>
          import ('../../views/auditsManagement/releaseDebtDetail'),
  },
    { //债权融资需求发布审核
        path: '/auditsManagement/releaseDemandDebt',
        name: 'auditsManagementReleaseDemandDebt',
        meta: { title: '债权融资需求发布审核'},
        component: () =>
            import ('../../views/auditsManagement/releaseDemandDebt'),
    },
    { //债权融资需求发布审核详情
      path: '/auditsManagement/releaseDemandDebt/detail/:type',
      name: 'auditsManagementReleaseDemandDebtDetail',
      meta: { title: '债权融资需求发布审核详情'},
      component: () =>
          import ('../../views/auditsManagement/releaseDemandDebtDetail'),
  },
    { //融资租赁申请审核
        path: '/auditsManagement/applicationFinancial',
        name: 'auditsManagementApplicationFinancial',
        meta: { title: '融资租赁申请审核'},
        component: () =>
            import ('../../views/auditsManagement/applicationFinancial')
    },
    { //融资租赁申请审核详情
      path: '/auditsManagement/applicationFinancial/detail/:type',
      name: 'auditsManagementApplicationFinancialDetail',
      meta: { title: '融资租赁申请审核详情'},
      component: () =>
          import ('../../views/auditsManagement/applicationFinancialDetail')
  },
  { //融资租赁申请审核产品详情
    path: '/auditsManagement/applicationFinancial/company/detail/:type',
    name: 'auditsManagementApplicationFinancialCompanyDetail',
    meta: { title: '融资租赁申请审核产品详情'},
    component: () =>
        import ('../../views/auditsManagement/applicationFinancialCompanyDetail')
},
    { //股权融资发布审核
        path: '/auditsManagement/releaseEquity',
        name: 'auditsManagementReleaseEquity',
        meta: { title: '股权融资发布审核'},
        component: () =>
            import ('../../views/auditsManagement/releaseEquity')
    },
    { //股权融资发布审核详情
      path: '/auditsManagement/releaseEquity/detail/:type',
      name: 'auditsManagementReleaseEquityDetail',
      meta: { title: '股权融资发布审核详情'},
      component: () =>
          import ('../../views/auditsManagement/releaseEquityDetail')
  },
    { //申请担保审核
        path: '/auditsManagement/applicationGuarantee',
        name: 'auditsManagementGpplicationGuarantee',
        meta: { title: '申请担保审核'},
        component: () =>
            import ('../../views/auditsManagement/applicationGuarantee')
    },
    { //申请担保审核详情
      path: '/auditsManagement/applicationGuarantee/detail/:type',
      name: 'auditsManagementGpplicationGuaranteeDetail',
      meta: { title: '申请担保审核详情'},
      component: () =>
          import ('../../views/auditsManagement/applicationGuaranteeDetail')
  },
  { //担保公司详情
    path: '/auditsManagement/applicationGuarantee/company/detail/:type',
    name: 'auditsManagementGpplicationGuaranteeCompanyDetail',
    meta: { title: '担保公司详情'},
    component: () =>
        import ('../../views/auditsManagement/applicationGuaranteeCompanyDetail')
},
    { //孵化器发布审核
        path: '/auditsManagement/releaseIncubator',
        name: 'auditsManagementReleaseIncubator',
        meta: { title: '孵化器发布审核'},
        component: () =>
            import ('../../views/auditsManagement/releaseIncubator')
    },
    { //孵化器发布审核详情
      path: '/auditsManagement/releaseIncubator/detail/:type',
      name: 'auditsManagementReleaseIncubatorDetail',
      meta: { title: '孵化器发布审核详情'},
      component: () =>
          import ('../../views/auditsManagement/releaseIncubatorDetail')
  },
  
    { //申请入驻孵化器审核
        path: '/auditsManagement/applicationIncubator',
        name: 'auditsManagementApplicationIncubator',
        meta: { title: '申请入驻孵化器审核'},
        component: () =>
            import ('../../views/auditsManagement/applicationIncubator')
    },
    { //申请入驻孵化器审核详情
      path: '/auditsManagement/applicationIncubator/detail/:type',
      name: 'auditsManagementApplicationIncubatorDetail',
      meta: { title: '申请入驻孵化器审核详情'},
      component: () =>
          import ('../../views/auditsManagement/applicationIncubatorDetail')
  },
  { //孵化器详情
    path: '/auditsManagement/applicationIncubator/company/detail/:type',
    name: 'auditsManagementApplicationIncubatorCompanyDetail',
    meta: { title: '孵化器详情'},
    component: () =>
        import ('../../views/auditsManagement/applicationIncubatorCompanyDetail')
},
    { //政策资讯发布审核
        path: '/auditsManagement/releasePolicy',
        name: 'auditsManagementReleasePolicy',
        meta: { title: '政策资讯发布审核'},
        component: () =>
            import ('../../views/auditsManagement/releasePolicy')
    },
    { //政策资讯发布审核详情
      path: '/auditsManagement/releasePolicy/detail/:type',
      name: 'auditsManagementReleasePolicyDetail',
      meta: { title: '政策资讯发布审核详情'},
      component: () =>
          import ('../../views/auditsManagement/releasePolicyDetail')
  },
    { //政策申报发布审核
        path: '/auditsManagement/releasePolicyDeclare',
        name: 'auditsManagementReleasePolicyDeclare',
        meta: { title: '政策申报发布审核'},
        component: () =>
            import ('../../views/auditsManagement/releasePolicyDeclare')
    },
    { //政策申报发布审核详情
      path: '/auditsManagement/releasePolicyDeclare/detail/:type',
      name: 'auditsManagementReleasePolicyDeclareDetail',
      meta: { title: '政策申报发布审核详情'},
      component: () =>
          import ('../../views/auditsManagement/releasePolicyDeclareDetail')
  },
    { //申请政策申报审核
        path: '/auditsManagement/applicationPolicyDeclare',
        name: 'auditsManagementApplicationPolicyDeclare',
        meta: { title: '申请政策申报审核'},
        component: () =>
            import ('../../views/auditsManagement/applicationPolicyDeclare')
    },
    { //申请政策申报审核详情
      path: '/auditsManagement/applicationPolicyDeclare/detail/:type',
      name: 'auditsManagementApplicationPolicyDeclareDetail',
      meta: { title: '申请政策申报审核详情'},
      component: () =>
          import ('../../views/auditsManagement/applicationPolicyDeclareDetail')
  },
  { //政策申报详细信息
    path: '/auditsManagement/applicationPolicyDeclare/company/detail/:type',
    name: 'auditsManagementApplicationPolicyDeclareCompanyDetail',
    meta: { title: '政策申报详细信息'},
    component: () =>
        import ('../../views/auditsManagement/applicationPolicyDeclareCompanyDetail')
},
    { //资讯发布审核
        path: '/auditsManagement/releaseNews',
        name: 'auditsManagementReleaseNews',
        meta: { title: '资讯发布审核'},
        component: () =>
            import ('../../views/auditsManagement/releaseNews')
    },
    { //资讯发布审核详情
      path: '/auditsManagement/releaseNews/detail/:type',
      name: 'auditsManagementReleaseNewsDetail',
      meta: { title: '资讯发布审核详情'},
      component: () =>
          import ('../../views/auditsManagement/releaseNewsDetail')
  },
    { //活动沙龙报名审核
        path: '/auditsManagement/applicationSalon',
        name: 'auditsManagementApplicationSalon',
        meta: { title: '活动沙龙报名审核'},
        component: () =>
            import ('../../views/auditsManagement/applicationSalon')
    },
    { //活动沙龙报名审核详情
      path: '/auditsManagement/applicationSalon/detail/:type',
      name: 'auditsManagementApplicationSalonDetail',
      meta: { title: '活动沙龙报名审核详情'},
      component: () =>
          import ('../../views/auditsManagement/applicationSalonDetail')
  },
  { //活动沙龙报名申请详情
    path: '/auditsManagement/applicationSalon/apply/detail/:type',
    name: 'auditsManagementApplicationSalonApplyDetail',
    meta: { title: '活动沙龙报名申请详情'},
    component: () =>
        import ('../../views/auditsManagement/applicationSalonApplyDetail')
},
    { //活动沙龙发布审核
        path: '/auditsManagement/releaseSalon',
        name: 'auditsManagementReleaseSalon',
        meta: { title: '活动沙龙发布审核'},
        component: () =>
            import ('../../views/auditsManagement/releaseSalon')
    },
    { //活动沙龙发布审核详情
      path: '/auditsManagement/releaseSalon/detail/:type',
      name: 'auditsManagementReleaseSalonDetail',
      meta: { title: '活动沙龙发布审核详情'},
      component: () =>
          import ('../../views/auditsManagement/releaseSalonDetail')
  },
    { //中介服务发布审核
        path: '/auditsManagement/releaseAgent',
        name: 'auditsManagementReleaseAgent',
        meta: { title: '中介服务发布审核'},
        component: () =>
            import ('../../views/auditsManagement/releaseAgent')
    },
    { //中介服务发布审核详情
      path: '/auditsManagement/releaseAgent/detail/:type',
      name: 'auditsManagementReleaseAgentDetail',
      meta: { title: '中介服务发布审核详情'},
      component: () =>
          import ('../../views/auditsManagement/releaseAgentDetail')
  },
    { //会员单位审核
        path: '/auditsManagement/memberUnits',
        name: 'auditsManagementMemberUnits',
        meta: { title: '会员单位审核'},
        component: () =>
            import ('../../views/auditsManagement/memberUnits')
    },
    { //会员单位审核详情
      path: '/auditsManagement/memberUnits/detail/:type',
      name: 'auditsManagementMemberUnitsDetail',
      meta: { title: '会员单位审核详情'},
      component: () =>
          import ('../../views/auditsManagement/memberUnitsDetail')
  },
  { //会员单位详情
    path: '/auditsManagement/memberUnits/units/detail/:id',
    name: 'auditsManagementMemberUnitsDetails',
    meta: { title: '会员单位详情'},
    component: () =>
        import ('../../views/auditsManagement/memberUnitsDetails')
},
    { //平台宣传发布审核
        path: '/auditsManagement/releasePush',
        name: 'auditsManagementReleasePush',
        meta: { title: '平台宣传发布审核'},
        component: () =>
            import ('../../views/auditsManagement/releasePush')
    },
    { //平台宣传发布审核详情
      path: '/auditsManagement/releasePush/detail/:id',
      name: 'auditsManagementReleasePushDetail',
      meta: { title: '平台宣传发布审核详情'},
      component: () =>
          import ('../../views/auditsManagement/releasePushDetail')
  },
  { //通知公告发布审核
    path: '/auditsManagement/notice',
    name: 'auditsManagementNotice',
    meta: { title: '通知公告发布审核'},
    component: () =>
        import ('../../views/auditsManagement/notice')
  },
  { //通知公告审核详情
    path: '/auditsManagement/notice/detail/:type/:id',
    name: 'auditsManagementNoticeDetail',
    meta: { title: '通知公告审核详情'},
    component: () =>
        import ('../../views/auditsManagement/noticeDetail')
},
  { //协会动态发布审核
    path: '/auditsManagement/association',
    name: 'auditsManagementAssociation',
    meta: { title: '协会动态发布审核'},
    component: () =>
        import ('../../views/auditsManagement/association')
  },
  { //协会动态审核详情
    path: '/auditsManagement/association/detail/:type/:id',
    name: 'auditsManagementAssociationDetail',
    meta: { title: '协会动态审核详情'},
    component: () =>
        import ('../../views/auditsManagement/associationDetail')
},
  { //附件资料发布审核
    path: '/auditsManagement/enclosure',
    name: 'auditsManagementEnclosure',
    meta: { title: '附件资料发布审核'},
    component: () =>
        import ('../../views/auditsManagement/enclosure')
  },
  { //附件资料审核详情
    path: '/auditsManagement/enclosure/detail/:type/:id',
    name: 'auditsManagementEnclosureDetail',
    meta: { title: '附件资料审核详情'},
    component: () =>
        import ('../../views/auditsManagement/enclosureDetail')
},
{ //集群托管服务申请审核
  path: '/auditsManagement/integrateManagement',
  name: 'auditsManagementIntegrateManagement',
  meta: { title: '集群托管服务申请审核'},
  component: () =>
      import ('../../views/auditsManagement/integrateManagement')
},
{ //集群托管服务申请审核详情
  path: '/auditsManagement/integrateManagement/detail/:type/:id',
  name: 'auditsManagementIntegrateManagementDetail',
  meta: { title: '集群托管服务申请审核详情'},
  component: () =>
      import ('../../views/auditsManagement/integrateManagementDetail')
},
{ //会员风采审核
  path: '/auditsManagement/memberStyle',
  name: 'auditsManagementMemberStyle',
  meta: { title: '会员风采审核'},
  component: () =>
      import ('../../views/auditsManagement/memberStyle')
},
{ //会员风采审核详情
  path: '/auditsManagement/memberStyle/detail/:type/:id',
  name: 'auditsManagementMemberStyleDetail',
  meta: { title: '会员风采审核详情'},
  component: () =>
      import ('../../views/auditsManagement/memberStyleDetail')
},
]